import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/AppIcon";

const Breadcrumbs = ({ items = [], className = "" }) => {
  return (
    <nav className={`flex ${className}`} aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          return (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <Icon 
                  name="ChevronRight" 
                  size={16} 
                  className="text-gray-400 mx-1" 
                  aria-hidden="true" 
                />
              )}
              
              {isLast ? (
                <span 
                  className="text-sm font-medium text-gray-500" 
                  aria-current="page"
                >
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="text-sm font-medium text-primary-600 hover:text-primary-700"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;